import React, { Component } from 'react';
import moment from 'moment';

import { dateRenderer, dateSorter } from './Helpers';
import UserModel from './UserModel';

import { Table, Badge, Divider } from 'antd';

class TinyNodeMessagesTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Čas přijetí',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200,
    defaultSortOrder: 'descend',
    sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
    render: (text, record) => dateRenderer(text)
  }, {
    title: 'Zpráva',
    dataIndex: 'message',
    key: 'message'
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default TinyNodeMessagesTable;


// WEBPACK FOOTER //
// ./src/components/TinyNodeMessagesTable.js